// Get deposit data from customer and apply it to the current cart
document.addEventListener("DOMContentLoaded", function () {
    subscribe(PUB_SUB_EVENTS.cartUpdate, async (data) => {
        if (data.cartData != undefined) {
            if (data.cartData.items.length == 0) {
                location.reload();
            }

            if (data.source != "cart-deposit") {
                await validateCart();
            }
        }
    });

    validateCart();
});

function getCheckoutButtons() {
    return document.querySelectorAll("#checkout, #CartDrawer-Checkout");
}

function getCartSubtotalsElements() {
    return document.querySelectorAll("#cart-subtotals, #CartDrawer-cart-subtotals");
}

function clearSubtotalsLoading() {
    getCartSubtotalsElements().forEach((element) => element.classList.remove("loading"));
}

window.clearCartSubtotalsLoading = clearSubtotalsLoading;

function toggleCheckoutButton(enabled) {
    getCheckoutButtons().forEach((checkoutButton) => {
        if (enabled) {
            checkoutButton.removeAttribute("disabled");
            checkoutButton.removeAttribute("aria-disabled");
        } else if (checkoutButton.tagName === "BUTTON") {
            checkoutButton.setAttribute("disabled", "disabled");
        } else {
            checkoutButton.setAttribute("aria-disabled", "true");
        }
    });
}

function shouldBlockCheckout() {
    if (document.querySelector(".cart__stock-error-message")) return true;
    if (document.querySelector(".free_delivery_info.under_minimum_order")) return true;
    return false;
}

async function validateCart() {
    const subtotalsElements = getCartSubtotalsElements();

    if (subtotalsElements.length === 0) {
        return;
    }

    const checkoutButtons = getCheckoutButtons();

    try {
        if (checkoutButtons.length === 0) {
            return;
        }

        toggleCheckoutButton(false);

        const baseUrl = window.location.origin;
        const cart = await fetch(`${baseUrl}/cart.js`).then((response) => response.json());

        if (cart.items.length === 0) {
            return;
        }

        const subtotalLine = document.querySelector("#main-cart-footer .subtotal_line.totals") || document.querySelector(".cart-drawer__footer .subtotal_line.totals");
        const groceryCost = Number(subtotalLine?.dataset?.groceryPrice || 0) / 100;
        const canUseRelaunch = subtotalLine?.dataset?.canUseRelaunch === "true";

        const resp = await fetch(`${baseUrl}/a/proxy/cart`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ cart_token: cart.token, grocery_cost: groceryCost, can_use_relaunch: canUseRelaunch }),
        }).then((response) => response.json());

        await renderCartSubtotals();

        if (resp.depositValidated && resp.creditAdded) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-deposit", cartData: cart });
        } else {
            console.warn("Deposit not validated or credit not added", resp);
        }
    } catch (error) {
        console.error("Cart deposit validation failed:", error);
    } finally {
        clearSubtotalsLoading();
        if (!shouldBlockCheckout()) {
            toggleCheckoutButton(true);
        }
    }
}

async function renderCartSubtotals() {
    await Promise.all([renderPageCartSubtotals(), renderDrawerCartSubtotals()]);
}

async function renderPageCartSubtotals() {
    const cartFooter = document.getElementById("main-cart-footer");
    const sectionId = cartFooter?.dataset?.id;

    if (!cartFooter || !sectionId) return;

    const sectionResp = await fetch(`${window.location.origin}/?sections=${sectionId}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    }).then((response) => response.json());

    const sectionHtml = sectionResp[sectionId];
    if (!sectionHtml) return;

    const parsedSection = new DOMParser().parseFromString(sectionHtml, "text/html");
    const newContents = parsedSection.querySelector(".js-contents");
    const targetContents = cartFooter.querySelector(".js-contents");

    if (newContents && targetContents) {
        targetContents.innerHTML = newContents.innerHTML;
        return;
    }

    const newCartFooter = parsedSection.querySelector("#main-cart-footer");

    if (newCartFooter) {
        cartFooter.replaceWith(newCartFooter);
        return;
    }

    cartFooter.innerHTML = sectionHtml;
}

async function renderDrawerCartSubtotals() {
    const drawerFooter = document.querySelector(".cart-drawer__footer");

    if (!drawerFooter) return;

    const sectionResp = await fetch(`${window.location.origin}/?sections=cart-drawer`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    }).then((response) => response.json());

    const sectionHtml = sectionResp["cart-drawer"];
    if (!sectionHtml) return;

    const parsedSection = new DOMParser().parseFromString(sectionHtml, "text/html");
    const newDrawerFooter = parsedSection.querySelector(".cart-drawer__footer");

    if (newDrawerFooter) {
        drawerFooter.replaceWith(newDrawerFooter);
    }
}
